// src/toastService.js
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Make sure you import this only once in your app, like in App.js or index.js

// Configure default toast options
const toastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Define toast success and error functions
const toastService = {
  showSuccess: (message) => {
    toast.success(message, toastConfig);
  },
  showError: (message) => {
    toast.error(message, toastConfig);
  },
  showInfo: (message) => {
    toast.info(message, toastConfig);
  },
  showWarning: (message) => {
    toast.warning(message, toastConfig);
  },
};

export default toastService;
